// extracted by mini-css-extract-plugin
export var mt0 = "fp-8r";
export var mt1 = "fp-9r";
export var mt2 = "fp-as";
export var mt3 = "fp-bs";
export var mt4 = "fp-cs";
export var mt5 = "fp-ds";
export var mt6 = "fp-es";
export var widgetShare = "fp-fs";
export var widgetShareTitle = "fp-gs";
export var widgetShare__item = "fp-js";
export var widgetShare__item__icon = "fp-ks";
export var widgetShare__item__link = "fp-ls";
export var widgetShare__item__notification = "fp-ms";
export var widgetShare__list = "fp-is";
export var widgetShare__title = "fp-hs";